// extracted by mini-css-extract-plugin
module.exports = {"MerchantGlobalFooter":"MerchantGlobalFooter_MerchantGlobalFooter__plrC_"};